import { DecoratedInvestorCompany } from '@flemingmetrics/api-client';

export const classes = {
  card: 'w-full py-8 px-4',
  section: 'mb-8',
  title: 'mb-4',
};

export function filterCompanies(
  searchQuery: string,
  companies: DecoratedInvestorCompany[]
) {
  const search = searchQuery.toLowerCase().trim();
  return companies.filter((ic) =>
    ic.company.name.toLowerCase().includes(search)
  );
}
